export const LOGIN_URL = "/auth/login";